/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect } from 'react'

import s from './FileInput.module.css'

export function FileInput({ initialFileUrl, onFileChange, accept = 'image/*' }) {
  const [previewUrl, setPreviewUrl] = useState(initialFileUrl || null)

  useEffect(() => {
    setPreviewUrl(initialFileUrl)
  }, [initialFileUrl])

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0]
    if (selectedFile) {
      const fileUrl = URL.createObjectURL(selectedFile)
      setPreviewUrl(fileUrl)

      if (onFileChange) {
        onFileChange(selectedFile)
      }
    }
  }

  return (
    <div className={s.root}>
      {previewUrl && (
        <div className={s.preview}>
          <img src={previewUrl} alt="Preview" className={s.previewImage} />
        </div>
      )}

      <input type="file" accept={accept} onChange={handleFileChange} style={{ display: 'none' }} id="file-input" />
      <label htmlFor="file-input" className={s.label}>
        Choose image
      </label>
    </div>
  )
}
